import { V2 } from "../theme/DesignV2";
import { Box } from "../box/Box";
import Spacer from "../spacer/Spacer";
import { Typo } from "../text/Typo";
import { RecursiveCSS } from "../theme/GlobalTheme";

export const Section = (props: {
  children: any;
  sx?: RecursiveCSS;
  label?: string;
  description?: string;
  rightZone?: React.ReactNode;
}) => {
  //setup labels
  const labels = props.label && (
    <Box>
      <Typo
        sx={{
          color: "#17243B",
          fontSize: "clamp(22px, 2vw, 26px)",
          fontWeight: "700",
          letterSpacing: "-0.035em",
          lineHeight: "1.2",
        }}
      >
        {props.label}
      </Typo>
      {props.description && (
        <Typo sx={{ fontSize: "14px", color: "#617087", lineHeight: "1.6", marginTop: "6px", display: "block" }}>
          {props.description}
        </Typo>
      )}
    </Box>
  );

  let content: JSX.Element | null = null;

  if (labels && !props.rightZone) {
    content = labels;
  }

  if (props.rightZone) {
    content = (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "minmax(0, 1fr) auto",
          alignItems: "start",
          gap: "12px 16px",
          "@media (max-width: 560px)": {
            gridTemplateColumns: "minmax(0, 1fr)",
          },
        }}
      >
        {labels}
        <Box
          sx={{ minWidth: 0, "@media (max-width: 560px)": { width: "100%" } }}
        >
          {props.rightZone}
        </Box>
      </Box>
    );
  }

  //!TODO: color from theme;

  return (
    <Box data-page-content
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "24px",
        backgroundColor: "transparent",
        borderRadius: "0px",
        //overflow: "auto",
        boxShadow: "none",
        minWidth: "0px",
        ...props.sx,
      }}
    >
      {content}
      {content && <Spacer size={V2.spacing} />}
      {props.children}
    </Box>
  );
};
